/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import i18n, { Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';

export const SUPPORTED_LOCALES = process.env.NEXT_PUBLIC_LOCALES ? process.env.NEXT_PUBLIC_LOCALES.split(',') : ['en'];

const resources = (() => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    return require('./generated-resources.json') as Resource;
  } catch {
    console.log('No generated resources, falling back to placeholder');
    return {} as Resource;
  }
})();

export function init() {
  void i18n.use(initReactI18next).init({
    resources,
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LOCALES,
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  });
}
